export class selfTemplateDetails{
    templateNo:number;
    jurisdictionId:number;
    constructor(){
        this.templateNo = 0;
        this.jurisdictionId = 0;
    }
}
export class impactAssessmentTemplateDetails{
    templateNo:number;
    jurisdictionId:number;
    constructor(){
        this.templateNo = 0;
        this.jurisdictionId = 0;
    }
}